import EditAccountForm from "./EditAccountForm";

export default EditAccountForm;
